import { editSavedCalendarView } from '../actions/publicActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { upsertSavedCalendarViewService } from '../services/upsertSavedCalendarViewService';

mutator(editSavedCalendarView, actionMessage => {
    let response = upsertSavedCalendarViewService(actionMessage.currentlyEditedView);
    if (response != null) {
        getStore().savedViewMap.set(
            actionMessage.currentlyEditedView.id,
            actionMessage.currentlyEditedView
        );
    }
});
